import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/css/base.css';
import i18n from "@/utils/i18";

import { createPinia } from 'pinia';
const pinia = createPinia();

import {getTest} from "@/utils/testHttp";
getTest();
createApp(App).use(i18n).use(router).use(pinia).mount('#app');
